module.exports = __webpack_public_path__ + "img/industrialAutomation.ab6cf210.png";